export const demo = (state,payload) => {    // 获得当前文章列表数组
}




// WEBPACK FOOTER //
// ./src/vuex/mutations.js